export interface ApiError {
  status: number;
  data: unknown;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const createApiError = async (response: Response): Promise<ApiError> => {
  let data: unknown = null;

  try {
    data = await response.json();
  } catch {
    // Algumas respostas de erro (como as de manutenção) não possuem JSON.
  }

  return { status: response.status, data };
};

const messageFromValue = (value: unknown): string | null => {
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return (
      value
        .map(messageFromValue)
        .find((message): message is string => !!message) || null
    );
  }
  return null;
};

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!isRecord(error) || !isRecord(error.data)) return fallback;

  return (
    messageFromValue(error.data.detail) ||
    messageFromValue(error.data.message) ||
    messageFromValue(error.data.non_field_errors) ||
    fallback
  );
};

export const getApiFieldErrors = (error: unknown): Record<string, string> => {
  if (!isRecord(error) || !isRecord(error.data)) return {};

  return Object.entries(error.data).reduce<Record<string, string>>(
    (fieldErrors, [field, value]) => {
      const message = messageFromValue(value);
      if (message) fieldErrors[field] = message;
      return fieldErrors;
    },
    {},
  );
};
